<template>
  <div class="user">
    <div class="user-container">
      <div class="top">
        <div class="title">选择您的身份标签</div>
        <div class="closeBtn" @click="close">跳过</div>
      </div>
      <div class="content">
        <div class="info">
          <div class="info-title">您所在的学校类型</div>
          <div class="info-btns">
            <div
              v-for="(school,index) in schoolTypeList"
              :key="index"
              class="info-btn"
              :class="{selectBtn: schoolType === school.id}"
              @click="select('school', school)"
            >
              {{ school.name }}
            </div>
          </div>
        </div>
        <div class="info">
          <div class="info-title">您所在教学段</div>
          <div class="info-btns">
            <div
              v-for="(period,index) in periodTypeList"
              :key="index"
              class="info-btn"
              :class="{selectBtn: periodId === period.id}"
              @click="select('period', period)"
            >
              {{ period.name }}
            </div>
          </div>
        </div>
        <div class="info">
          <div class="info-title">您所在教的学科</div>
          <div class="info-btns">
            <div
              v-for="(subject,index) in subjectTypeList"
              :key="index"
              class="info-btn"
              :class="{selectBtn: subjectId === subject.id}"
              @click="select('subject', subject)"
            >
              {{ subject.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="submitBtn" @click="submit">完成</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCommonInfo } from '@/api/common';
import { modUserInfo } from '@/api/user';
export default {
  name: 'UserInfo',
  components: {
  },
  data() {
    return {
      subjectTypeList: [],
      periodTypeList: [],
      schoolTypeList: [],
      schoolType: null,
      periodId: null,
      subjectId: null
    };
  },
  computed: {
  },
  mounted() {
    getCommonInfo().then(res => {
      if (res.code === 200) {
        const { periodTypeList, schoolTypeList, subjectTypeList } = res.data;
        this.subjectTypeList = subjectTypeList;
        this.periodTypeList = periodTypeList;
        this.schoolTypeList = schoolTypeList;
      }
    });
  },
  methods: {
    select(type, item) {
      switch (type) {
        case 'school':
          this.schoolType = item.id;
          break;
        case 'period':
          this.periodId = item.id;
          break;
        case 'subject':
          this.subjectId = item.id;
          break;
      }
    },
    submit() {
      const params = {
        subject: this.subjectId,
        period: this.periodId,
        schoolType: this.schoolType
      };
      modUserInfo(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '设置成功',
            type: 'success'
          });
          this.$emit('close');
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      });
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
  <style lang="scss" scoped>
  .user {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(50, 50, 51, 0.30);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .user-container {
    width: 690px;
    flex-shrink: 0;
    background-color: #fff;
    border-radius: 10px;
    padding: 33px 30px;
  }
  .title {
    color: #0F0F10;
    font-family: "PingFang SC";
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .info {
    margin-top: 14px;
    &-title {
      color: #0F0F10;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 13px;
    }
    &-btns {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 16px;
    }
    &-btn {
      width: 113px;
      height: 46px;
      flex-shrink: 0;
      color: #323233;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      border-radius: 10px;
      border: 1px solid #EAEAEA;;
      text-align: center;
      line-height: 46px;
      &:hover {
        cursor: pointer;
        color: #0D70ED;
        border: 1px solid #0D70ED;
      }
    }
  }
  .selectBtn {
    color: #0D70ED;
    border: 1px solid #0D70ED;
  }
  .submitBtn {
    width: 160px;
    height: 46px;
    flex-shrink: 0;
    border-radius: 8px;
    background: linear-gradient(153deg, #3774F3 -24.36%, #1A87F4 106.05%);
    color: #FFF;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 46px; /* 157.143% */
    margin: auto;
    margin-top: 34px;
    &:hover {
      cursor: pointer;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
  }
  .closeBtn {
    width: 60px;
    height: 30px;
    flex-shrink: 0;
    border-radius: 25px;
    border: 1px solid #CCC;
    text-align: center;
    line-height: 30px;
    &:hover {
      cursor: pointer;
    }
  }
  </style>
